import * as React from "react";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { GiaContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/PersonalPortfolio/GiaContributionModel";
import { IsaContributionModel } from "../../../../../../Wrap/Models/Models/Processes/OneOffPayment/Isa/IsaContributionModel";
import { ProcessType } from "../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { Typography } from "../../../../../Shared/Typography/Typography";
import { subAccountTypeMap } from "../../PortfolioDashboard/Components/Performance/Resource/Contents";
import { IllustrationsAvailable } from "../../Common/Documents/Components/IllustrationsAvailable";
import { NoChangeToolStore } from "../Store/Variable";
import { InstructionDocumentTypeRequestTriggerActionsCreator } from "../../Common/Documents/Actions/InstructionDocumentTypeRequestTriggerActionsCreator";
import { DocumentCategory } from "../../../../../../Wrap/Constants/Enums/Domain/DocumentCategory";

interface IReviewProps extends IProcessComponentProps {
    data: GiaContributionModel | IsaContributionModel;
    type: SubAccountType;
}

interface IReviewState {}

export class Review extends ProcessComponent<IReviewProps, IReviewState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        super.componentDidMount();

        const data = NoChangeToolStore.getData();
        InstructionDocumentTypeRequestTriggerActionsCreator.triggerByInstructionId(data.HierarchyId as string, [
            DocumentCategory.Illustration,
        ]);
    }

    private getStepReviewProps = () => {
        return {
            data: this.props.data?.Contribution,
            subAccountType: this.props.type,
            process: ProcessType.Quote,
            colNum: 2,
        };
    };

    private successLabelRender() {
        const { data, type } = this.props;
        const createdDate = JsonDateParser.getFormatDateString(new Date(), "dd MM yyyy", true);
        const reference = data?.HierarchyId;
        const config = [
            {
                title: "Created:",
                data: createdDate,
            },
            {
                title: "Wrapper:",
                data: subAccountTypeMap[type],
            },
        ];
        return (
            <div>
                <h1>
                    <span className="alert-success">No change tool {reference} successfully created</span>
                </h1>
                <br />
                <h2>No change wizard No. {reference}</h2>
                <Typography type="narrow-dt-width" wrapCss="quote-list" config={config}></Typography>
                <IllustrationsAvailable onRef={(ref) => this.appendChild(ref)} onChange={() => {}} data={data} />
            </div>
        );
    }

    render() {
        const { data, type } = this.props;
        return <>{this.successLabelRender()}</>;
    }
}
